import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

interface IProps {
    onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    children?: React.ReactNode;
}

const ModalWrapper: React.FC<IProps> = ({ children, onClick }) => {
    const elem = useRef(document.createElement("div"));

    useEffect(() => {
        if (!elem.current) {
            elem.current = document.createElement("div");
        }

        const root = document.getElementById("modal-root");

        root?.appendChild(elem.current);

        return function removeElement() {
            elem.current.remove();
        }
    }, [])

    return (
         createPortal(
            <div 
                id="modal-overlay" 
                className="fixed top-0 left-0 w-full h-full overflow-auto bg-opacity-80 bg-black pt-10 z-10"
                onClick={event => onClick(event)}
            >
               {children}
            </div>,
            elem.current
        )
    )
};

export default ModalWrapper;